
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    containerTable: {
        display: 'table',
        width: '100%'
    },
    containerTableCell: {
        display: 'table-cell'
    },
    containerTableCell_fullWidth: {
        width: '100%'
    },
    containerTableCell_alignMiddle: {
        verticalAlign: 'middle'
    },
    link: {
        fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
        fontSize: '19px',
        lineHeight: '24px',
        letterSpacing: undefined,
        paddingTop: '12px',
        paddingBottom: '12px',
        paddingLeft: '0px',
        marginLeft: '0px',
        border: 'none',
        backgroundColor: '#fff',
        color: '#484848',
        fontWeight: 300,
        display: 'block',
        textDecoration: 'none',
        position: 'relative'
    },
    list: {
        padding: '0px',
        listStyleType: 'none'
    },
    content_baseline: {
        display: 'table',
        padding: '16px 0',
        color: '#484848',
        width: '100%'
    },
    container_link: {
        display: 'block',
        padding: '0 16px',
        textDecoration: 'none'
    },
    container_table: {
        display: 'table',
        width: '100%'
    },
    container_table_child: {
        display: 'table-cell',
        width: '100%',
        verticalAlign: 'middle'
    },
    text: {
        color: '#767676',
        fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
        margin: '0px',
        wordWrap: 'break-word',
        fontSize: '15px',
        lineHeight: '18px',
        letterSpacing: '0.2px',
        paddingTop: '0px',
        paddingBottom: '0px'
    },
    menuIndicator: {
        color: '#767676',
        display: 'table-cell',
        fontSize: '9px',
        paddingLeft: '8px',
        verticalAlign: 'middle',
        transition: '1s color',
        '@media (min-width: 1025px)': {
            display: 'none'
        },
        '@media (max-width: 744px)': {
            paddingLeft: '15px'
        }
    },
    iconWrapper: {
        display: 'table-cell',
        verticalAlign: 'middle',
        transitionProperty: '-ms-transform,-webkit-transform,transform',
        transitionDuration: '250ms',
        transitionTimingFunction: 'ease-in-out'
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/Header/FlyoutMenu/FlyoutNav/FlyoutNavLinkGroup/styles.js